var App = App || {};

App.WidgetFaq = (function ($) {
    'use strict';

    function Accordion(selector) {

        if (selector.length) {

            selector.each(function () {

                const component = $(this);
                const toggleButtons = component.find("button[aria-controls]");

                toggleButtons.each(function () {
                    const button = $(this);
                    const accordionId = button.attr("aria-controls");

                    if (!accordionId) {
                        return;
                    }

                    const accordion = component.find(`.accordion[id='${accordionId}']`).first();

                    if (!accordion.length) {
                        return;
                    }

                    if (!button.data("expandedLabel") || !button.data("collapsedLabel")) {
                        const initialLabel = $.trim(button.text());
                        const isViewVariant = /^view/i.test(initialLabel);
                        button.data("expandedLabel", isViewVariant ? "View less" : "Show less");
                        button.data("collapsedLabel", isViewVariant ? "View more" : "Show all");
                    }

                    button.off("click.widgetFaqAccordion").on("click.widgetFaqAccordion", function () {
                        const isExpanded = button.attr("aria-expanded") === "true";

                        if (!isExpanded) {
                            button.attr("aria-expanded", "true").text(button.data("expandedLabel"));
                            accordion.find(".accordion-item.d-none").addClass("accordion-item-conditional").removeClass("d-none");
                        }
                        else {
                            button.attr("aria-expanded", "false").text(button.data("collapsedLabel"));
                            accordion.find(".accordion-item.accordion-item-conditional").removeClass("accordion-item-conditional").addClass("d-none");
                        }
                    });
                });
            });
        }
    }

    return {
        Accordion: Accordion
    };

})(jQuery);